export var I18N_NS = 'common_translations';